import dayjs from 'dayjs';

export function formatDateIfCurrentYear(dateInput: string | Date) {
  const date = dayjs(dateInput);
  const isCurrentYear = date.year() === dayjs().year();

  return isCurrentYear ? date.format('D MMMM, HH:mm') : date.format('D MMMM YYYY, HH:mm');
}
